import { TextareaAutosize } from "@mui/base";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FIELD_STYLES, TEMPLATE_TYPES } from "../../../constants";

const TemplateFields = ({ control }) => {
  const [focusedField, setFocusedField] = useState(null);
  const { watch } = useFormContext(control);

  const templateFields = watch("templateFields");
  const templateType = watch("templateType");

  // Show only the field with fieldIdx === 0 for CUSTOM templates
  const visibleFields = templateFields
    .filter(
      (field) =>
        templateType !== TEMPLATE_TYPES.CUSTOM ||
        field.fieldIdx === 0,
    )
    .sort((a, b) => a.fieldIdx - b.fieldIdx);

  return (
    <div className="flex flex-col gap-2">
      {visibleFields.map((field, index) => {
        const styles =
          FIELD_STYLES[field.fieldName] || FIELD_STYLES.default;

        const currentPlaceholder =
          field.fieldName === focusedField
            ? styles.placeholder
            : styles.simplePlaceholder;

        return (
          <div
            key={index}
            className={`flex flex-row items-start gap-4 rounded-xl ${styles.container}`}
          >
            {templateType === TEMPLATE_TYPES.SOAP && (
              <span
                className={`text-xl m-2 font-bold ${styles.text}`}
              >
                {field.fieldName.charAt(0)}
              </span>
            )}
            <Controller
              control={control}
              name={`templateFields.${index}.fieldValue`}
              defaultValue={field.fieldValue}
              render={({
                field: { onChange, onBlur, value, ref },
              }) => (
                <TextareaAutosize
                  id={`textarea-${index}`}
                  minRows={field.fieldName === "CUSTOM" ? 5 : 3}
                  value={value}
                  onChange={onChange}
                  onFocus={() => setFocusedField(field.fieldName)}
                  onBlur={(e) => {
                    onBlur(e);
                    setFocusedField(null);
                  }}
                  placeholder={currentPlaceholder}
                  className={`resize-none appearance-none relative block w-full bg-transparent placeholder-gray-400 rounded-xl text-xs md:text-sm h-8 ${
                    field.fieldName === "CUSTOM"
                      ? "p-3 border-2 border-gray-100 dark:border-gray-800/50 focus:border-indigo-300"
                      : "p-2"
                  }`}
                  ref={ref}
                />
              )}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TemplateFields;
